import {ApplicationStoreType} from 'reducers';

import {MODULE_KEY} from '../../constants';
import {PostPurchaseInsuranceStepType} from './types';

/**
 * Returns current step
 * @param {ApplicationStoreType} store - ApplicationStoreType
 * @return {PostPurchaseInsuranceStepType} - current step
 */
export const getCurrentStep = (store: ApplicationStoreType): PostPurchaseInsuranceStepType =>
    store[MODULE_KEY].step;
